import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Get Help - Food Page
const FoodPage = () => {
  return (
    <div data-testid="food-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/696ykqio_Produce%20woman%20%26%20volunteer.jpg"
        alt="Food Distribution"
        objectPosition="center 25%"
      />

      {/* Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="food-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              How to register for a food distribution
            </h1>
            
            <div className="text-[#1A1A1A] text-base md:text-lg leading-relaxed space-y-6">
              <div>
                <p className="font-semibold text-[#1A1A1A] mb-2">You must come to register in person between 8:00 and 10:00am.</p>
                <ul className="list-none space-y-1 ml-4 text-lg md:text-xl font-bold">
                  <li><span className="font-bold">Mondays:</span> Ages 55+</li>
                  <li><span className="font-bold">Tuesdays:</span> Ages 18-54</li>
                </ul>
                <p className="mt-3 font-semibold text-[#1A1A1A]">
                  IMPORTANT: Only one person per household may register. That person may share the account with other household members.
                </p>
              </div>

              <div>
                <p className="font-semibold text-[#1A1A1A] mb-2">To register:</p>
                <ul className="list-disc ml-6 space-y-2">
                  <li>Please bring an ID if you have one, and wait in the line. Please do not arrive before 8:00am.</li>
                  <li>You must bring your own bags. You may also bring a small shopping cart.</li>
                  <li>If you follow a halal diet, let the person registering you know.</li>
                  <li>Park on the streets near the pantry. Do not park in any business lots - you will be towed!</li>
                </ul>
              </div>

              <p className="italic">
                Please treat all guests, volunteers, staff, and neighbors with respect, regardless of age, race, ethnicity, national origin, color, sex, gender, sexual orientation, disability, religion, or circumstances.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default FoodPage;
